import registerGlobalComponentsListener from './RegisterGlobalComponentsListener'
import interceptadorHttp from './InterceptadorHttp'

export default {
    registerGlobalComponentsListener,
    interceptadorHttp
}
